import type { SelectOption } from "../../../ui/index.ts";

export const APPROVAL_CENTER_STATUS_OPTIONS: SelectOption[] = [
  { value: "PENDING_PREJOINING", label: "Pending Pre-Joining" },
  { value: "PENDING_POSTJOINING", label: "Pending Post-Joining" },
  { value: "PENDING_REVIEW", label: "Pending Review" },
  { value: "PENDING_INSURANCE", label: "Pending Insurance" },
  { value: "APPROVED", label: "Approved" },
  { value: "NEEDS_CORRECTION", label: "Needs Correction" },
  { value: "REJECTED", label: "Rejected" },
];

export const DEFAULT_APPROVAL_CENTER_STATUS = "PENDING_POSTJOINING";

export const SQE_APPROVAL_CENTER_STATUS_OPTIONS: SelectOption[] = [
  { value: "PENDING_PREJOINING", label: "Pending Pre-Joining" },
  { value: "PENDING", label: "Pending Post-Joining" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
];

export const SQE_DEFAULT_APPROVAL_CENTER_STATUS = "PENDING";

export const APPROVAL_CENTER_REGION_OPTIONS: SelectOption[] = [
  { value: "CCI_INDIA", label: "India" },
  { value: "CCI_US", label: "US" },
];
